import feather from 'feather-icons';

export const linkActivationMixin = {
	mounted() {
		// Code that will run only after the
		// entire view has been rendered
		this.$nextTick(function () {
			var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
			var sidenavs = document.querySelectorAll('#layoutSidenav_nav .sidenav a.nav-link')
			sidenavs.forEach(function(element) {
				if (element.href === path)
					element.classList.add('active');
				
				// FAIT SCROLLER EN HAUT SI Link
				if(element.classList.value === 'nav-link'){
					element.addEventListener('click', (event) => {
						window.scrollTo({
							top: 0,
							behavior: 'smooth' // Pour un défilement fluide
						});
						// event.preventDefault(); 
					});
				}

			});
			// Activate Feather icons
			feather.replace();
		})
	}
}